<template>
  <div>
    <HearderTitle name="转入员工" />
    <div class="personnelFrom">
      <el-form ref="personnelFrom" :rules="rules" :model="personnelFrom" label-width="110px" :inline="true" size="small">
        <p class="title">个人信息</p>
        <el-form-item label="姓名" prop="pername">
          <el-input v-model="personnelFrom.pername"></el-input>
        </el-form-item>
        <el-form-item label="照片" class="photo" prop="photo">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handlePhotoSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="personnelFrom.photo" :src="personnelFrom.photo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="personnelFrom.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item></el-form-item>
        <el-form-item label="联系方式" prop="contact" style="padding-left: 70px">
          <el-input v-model="personnelFrom.contact"></el-input>
        </el-form-item>
        <el-form-item label="其他联系方式" prop="othercontact" style="padding-left: 70px">
          <el-input v-model="personnelFrom.othercontact"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="cardid">
          <el-input @blur="chenge(personnelFrom.cardid)" v-model="personnelFrom.cardid"></el-input>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker v-model="personnelFrom.birthday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="户籍" prop="province">
          <el-input v-model="personnelFrom.province"></el-input>
        </el-form-item>
        <el-form-item label="户籍所在地" prop="address">
          <el-input v-model="personnelFrom.address"></el-input>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-input v-model="personnelFrom.nation"></el-input>
        </el-form-item>
        <el-form-item label="政治面貌" prop="organ">
          <el-input v-model="personnelFrom.organ"></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-input v-model="personnelFrom.school"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="edu">
          <el-input v-model="personnelFrom.edu"></el-input>
        </el-form-item>
        <el-form-item label="专业" prop="manjor">
          <el-input v-model="personnelFrom.manjor"></el-input>
        </el-form-item>
        <el-form-item label="婚姻状态" prop="marrage">
          <el-radio-group v-model="personnelFrom.marrage">
            <el-radio label="未婚"></el-radio>
            <el-radio label="已婚"></el-radio>
          </el-radio-group>
        </el-form-item>
        <p class="title">入职信息</p>
        <el-form-item label="所属部门" prop="dep_id">
          <el-select v-model="personnelFrom.dep_id" placeholder="请选择" ref="selectTree" @change="changeDep(personnelFrom.dep_id)">
            <el-option v-for="item in datalist" :key="item.id" :value="item.name" :label="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职务" prop="roles">
          <el-select v-model="personnelFrom.roles" placeholder="请选择">
            <el-option v-for="item in childrenData" :key="item.id" :value="item.name" :label="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间" prop="inday">
          <el-date-picker v-model="personnelFrom.inday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="stu">
          <el-select v-model="personnelFrom.stu" clearable>
            <el-option label="试岗期" :value="1"></el-option>
            <el-option label="试用期" :value="2"></el-option>
            <el-option label="正式员工" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签合年限" prop="pactyear">
          <el-input v-model="personnelFrom.pactyear"></el-input>
        </el-form-item>
        <el-form-item label="合同到期时间" prop="endpactday">
          <el-date-picker v-model="personnelFrom.endpactday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="上次合同时间" prop="prepactday">
          <el-date-picker v-model="personnelFrom.prepactday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <el-form-item label="签合同次数" prop="pactnum">
          <el-input v-model="personnelFrom.pactnum"></el-input>
        </el-form-item>
        <el-form-item label="转正时间" prop="trial_period_end">
          <el-date-picker v-model="personnelFrom.trial_period_end" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
        </el-form-item>
        <p class="title">简历图片</p>
        <div></div>

        <el-form-item label="备注" prop="moreinfo">
          <el-input class="moreinfo" v-model="personnelFrom.moreinfo"></el-input>
        </el-form-item>
        <el-form-item class="upload pics" label="简历上传" prop="pics">
          <el-input class="moreinfo" :limit="1" readonly v-model="personnelFrom.pics"> </el-input>
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"> 上传 <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload>
        </el-form-item>
        <el-form-item class="upload" label="上传照片" prop="perzp">
          <el-input class="moreinfo" :limit="1" readonly v-model="personnelFrom.perzp"> </el-input>
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handlePerzpSuccess" :before-upload="beforeAvatarUpload"> 上传 <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload>
        </el-form-item>
        <div></div>

        <el-form-item>
          <el-button class="lightBlueBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <el-button plain size="small" @click="$refs['personnelFrom'].resetFields()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getAuditionInfoById, transferEmployee } from '@/api/audition.js'
  import { getDepList } from '@/api/common.js'
  import { getOutsourcingInfoById } from '@/api/personnelList.js'
  import HearderTitle from '@/components/HearderTitle'
  import { getUserInfoByidNumber } from '@/util/index.js'
  export default {
    name: 'transferIn',
    data() {
      return {
        personnelFrom: {
          pername: '',
          sex: '',
          contact: '',
          othercontact: '',
          cardid: '',
          birthday: '',
          province: '',
          address: '',
          nation: '',
          organ: '',
          school: '',
          edu: '',
          manjor: '',
          marrage: '',
          dep_id: '',
          roles: '',
          inday: '',
          stu: null,
          pactyear: null,
          endpactday: '',
          prepactday: '',
          pactnum: '',
          moreinfo: '',
          pics: '',
          perzp: '',
          trial_period_end: null,
          photo: '',
        },
        datalist: [],
        depList: [],
        childrenData: [],
        rules: {
          pername: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
          sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
          contact: [
            { required: true, message: '联系方式不能为空', trigger: 'blur' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          cardid: [{ required: true, message: '身份证不能为空', trigger: 'blur' }],
          birthday: [{ required: true, message: '生日不能为空', trigger: 'blur' }],
          province: [{ required: true, message: '户籍不能为空', trigger: 'blur' }],
          address: [{ required: true, message: '户籍所在地不能为空', trigger: 'blur' }],
          nation: [{ required: true, message: '民族不能为空', trigger: 'blur' }],
          school: [{ required: true, message: '学校不能为空', trigger: 'blur' }],
          edu: [{ required: true, message: '学历不能为空', trigger: 'blur' }],
          manjor: [{ required: true, message: '专业不能为空', trigger: 'blur' }],
          marrage: [{ required: true, message: '婚姻状态不能为空', trigger: 'blur' }],
          dep_id: [{ required: true, message: '所属部门不能为空', trigger: 'blur' }],
          roles: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
          inday: [{ required: true, message: '入职时间不能为空', trigger: 'blur' }],
          stu: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
          pactyear: [{ required: true, message: '签合年限不能为空', trigger: 'blur' }],
          pactnum: [{ required: true, message: '签合同次数不能为空', trigger: 'blur' }],
          trial_period_end: [{ required: true, message: '转正时间不能为空', trigger: 'blur' }],
        },
        uploadUrl: '',
        title: '',
        personnelInfo: {},
        id: '',
      }
    },
    async created() {
      let { data } = await getDepList()
      this.depList = data
      data.forEach((v) => {
        if (v.pid === 0) {
          this.datalist.push(v)
        }
      })
      // 获取上传url
      this.uploadUrl = process.env.VUE_APP_API_URL + '/mypub/loaddail?ty=hr'
      // 获取编辑页面id
      let id = ''
      if (this.$route.params.id) {
        id = this.$route.params.id
        sessionStorage.setItem('audition', id)
      } else {
        id = JSON.parse(sessionStorage.getItem('audition'))
      }
      this.id = id
      this.getAuditionInfoById(id)
    },
    methods: {
      changeDep(val) {
        this.personnelFrom.roles = ''
        this.depList.forEach((v) => {
          if (val == v.name) {
            this.childrenData = v.children
          }
        })
      },
      // 提交
      async seve() {
        let that = this
        this.$refs['personnelFrom'].validate(async (valid) => {
          if (!valid) return
          if (this.id !== '') {
            let data = {
              id: this.id,
              pername: this.personnelFrom.pername,
              sex: this.personnelFrom.sex,
              contact: this.personnelFrom.contact,
              othercontact: this.personnelFrom.othercontact,
              cardid: this.personnelFrom.cardid,
              birthday: this.personnelFrom.birthday,
              province: this.personnelFrom.province,
              address: this.personnelFrom.address,
              nation: this.personnelFrom.nation,
              organ: this.personnelFrom.organ,
              school: this.personnelFrom.school,
              edu: this.personnelFrom.edu,
              manjor: this.personnelFrom.manjor,
              marrage: this.personnelFrom.marrage,
              dep_id: this.personnelFrom.dep_id,
              roles: this.personnelFrom.roles,
              inday: this.personnelFrom.inday,
              stu: this.personnelFrom.stu,
              pactyear: this.personnelFrom.pactyear,
              endpactday: this.personnelFrom.endpactday,
              prepactday: this.personnelFrom.prepactday,
              pactnum: this.personnelFrom.pactnum,
              moreinfo: this.personnelFrom.moreinfo,
              pics: this.personnelFrom.pics,
              perzp: this.personnelFrom.perzp,
              msper: this.personnelFrom.msper,
              mspj: this.personnelFrom.mspj,
              photo: this.personnelFrom.photo,
            }
            let res = await transferEmployee(data)
            if (res.status !== 200) return this.$message.error('提交失败')
            this.$message.success('提交成功')
            return this.$router.go(-1)
          }
        })
      },
      // 根据id查询人员信息
      async getAuditionInfoById(id) {
        let res
        console.log(this.$route.params.type)
        if (this.$route.params.type === 'outsourcing') {
          res = await getOutsourcingInfoById({ id })
        } else {
          res = await getAuditionInfoById({ id })
        }
        if (res.status === 201) return

        let { pics, pername, birthday, contact, gangwei, isj, isp, manjor, marrage, msday, ptime, sex, source, school, msper, mspj } = res.data
        this.personnelFrom.pics = pics
        this.personnelFrom.pername = pername
        this.personnelFrom.birthday = birthday
        this.personnelFrom.contact = contact
        this.personnelFrom.marrage = marrage
        this.personnelFrom.sex = sex
        this.personnelFrom.school = school
        this.personnelFrom.msper = msper
        this.personnelFrom.mspj = mspj
      },
      // 上传简历
      handleAvatarSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        let len = this.personnelFrom.pics.length
        if (len === 0) {
          this.personnelFrom.pics += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.personnelFrom.pics += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 上传图片
      handlePerzpSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.personnelFrom.perzp = 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
      },
      // 上传限制
      beforeAvatarUpload(file) {
        const isJPG = ['image/jpeg', 'image/png']
        const isLt5M = file.size / 1024 / 1024 < 6
        if (!isJPG.includes(file.type)) {
          this.$message.error('上传头像图片只能是JPG或PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传头像图片大小不能超过 5MB!')
        }
        return isJPG.includes(file.type) && isLt5M
      },
      // 上传照片
      handlePhotoSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.personnelFrom.photo = 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        console.log('this.personnelFrom.photo: ', this.personnelFrom.photo)
      },

      // 根据身份证号获取信息
      chenge(val) {
        console.log(!new RegExp(/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/).test(val))
        if (!new RegExp(/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/).test(val)) return
        let { province, birthday, sex } = getUserInfoByidNumber(val)
        this.personnelFrom.sex = sex
        this.personnelFrom.birthday = birthday
        this.personnelFrom.province = province
      },
    },

    components: { HearderTitle },
    watch: {
      'personnelFrom.dep_id': function (val, oldVal) {
        console.log(val, oldVal)
        this.depList.forEach((v) => {
          if (val == v.name) {
            this.childrenData = v.children
          }
        })
      },
    },
  }
</script>

<style lang="less">
  .personnelFrom {
    margin: 0 auto;
    margin-top: 40px;
    width: 976px;
    .title {
      font-size: 14px;
      color: #666666;
      border-left: 3px solid #1f7ac3;
      height: 14px;
      padding-left: 5px;
      line-height: 14px;
      margin-bottom: 5px;
    }
    .el-form-item {
      padding-left: 70px;
      &:nth-of-type(2n) {
        padding-left: 40px;
      }
      &.pics {
        padding-left: 70px;
        .el-form-item__label {
          width: 80px !important;
        }
      }
      &.upload {
        position: relative;
        .avatar-uploader {
          background-color: #fff;
          position: absolute;
          right: 10px;
          top: 0;
          color: #b3b3b3;
          height: 30px;
          margin-top: 1px;
        }
      }
      &:last-of-type {
        margin-top: 10px;
        // margin-bottom: ;
        display: flex;
        justify-content: center;
        .el-button {
          width: 112px;
          height: 32px;
          padding: 0;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          margin-right: 20px;
        }
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner,
      .el-input__inner {
        width: 300px;
      }
      .el-date-editor .el-input__inner {
        padding-left: 15px;
      }
      .moreinfo {
        width: 100%;
        .el-input__inner {
          width: 760px;
        }
      }
    }
    .photo {
      display: block;
      float: right;
      padding-left: 0px !important;
      margin-right: 232px;
      margin-left: 0;
      margin-bottom: 0;
      margin-top: 30px;
      .el-form-item__label {
        width: 50px !important;
      }
      .el-upload--picture-card {
        width: 100px;
        height: 136px;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 136px;
        line-height: 136px;
        text-align: center;
        background: #eee;
      }
      .avatar {
        width: 100px;
        height: 136px;
        display: block;
      }
    }
  }
</style>
